/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { OPEN_STATUS_MAPPING } from '@/common/constants/bank';

export default [
  {
    width: 180,
    label: '姓名',
    tip: '请输入关键字',
    key: 'fullName',
    id: 'fullName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '个体',
    tip: '请输入个体名称',
    key: 'enterpriseName',
    id: 'enterpriseName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '手机号',
    tip: '请输入手机号',
    key: 'phone',
    id: 'phone',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '支付通道',
    tip: '请选择支付通道开通状态',
    key: 'openStatus',
    id: 'openStatus',
    slot: 'select',
    clearable: true,
    options: Object.values(OPEN_STATUS_MAPPING).map(item => {
      return {
        name: item.label,
        key: item.value
      };
    })
  },
  {
    width: 180,
    label: '入驻状态',
    tip: '请选择入驻状态',
    key: 'inStatus',
    id: 'status',
    slot: 'select',
    clearable: true,
    options: [
      {
        key: 0,
        name: '未入驻'
      },
      {
        key: 1,
        name: '已入驻'
      },
      {
        key: 2,
        name: '已退出'
      },
      {
        key: 3,
        name: '不可入驻'
      }
    ]
  },
  {
    width: 180,
    label: '认证状态',
    tip: '请选择认证状态',
    key: 'userAuthStatus',
    id: 'userAuthStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '未认证',
        key: 0
      },
      {
        name: '已认证',
        key: 1
      },
      {
        name: '认证失败',
        key: 2
      }
    ]
  },
  {
    width: 180,
    label: '是否可执行项目',
    tip: '请选择是否可执行项目',
    key: 'status',
    id: 'ifExecutableStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '是',
        key: 1
      },
      {
        name: '否',
        key: 2
      }
    ]
  },
  {
    width: 180,
    label: '人员标签',
    tip: '请输入关键字',
    key: 'userTag',
    id: 'personLabel',
    slot: 'autocomplete',
    maxLength: 30,
    clearable: true,
    callback: function() {
      this.customQuery.notSet = this.customQuery.userTag === '未设置' ? 1 : 0;
    },
    querySearch: (queryString, cb) => {
      cb(
        [{ value: '未设置' }].filter(
          i => !queryString || i.value.indexOf(queryString) > -1
        )
      );
    }
  },
  {
    width: 180,
    label: '资质审核状态',
    tip: '请选择资质审核状态',
    key: 'certificationStatus',
    id: 'certificationStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '待审核',
        key: 1
      },
      {
        name: '审核通过',
        key: 2
      },
      {
        name: '审核未通过',
        key: 3
      }
    ]
  }
];
